'use client';

import { Suspense, useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';
import { initMixpanel, trackPageView } from '@/lib/mixpanel';

function MixpanelPageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { user } = useAuth();

  useEffect(() => {
    trackPageView({
      page_url: window.location.href,
      page_title: document.title,
      user_id: user?.id,
    });
  }, [pathname, searchParams, user?.id]);

  return null;
}

export function MixpanelProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initMixpanel();
  }, []);

  return (
    <>
      <Suspense fallback={null}>
        <MixpanelPageViewTracker />
      </Suspense>
      {children}
    </>
  );
}
